import {Column, TO_LOCALE_DATE_STRING_OPTIONS} from '../../../core/TableWithSortAndPagination';

import {ExecutionSetupDTO} from 'hemwb-api';
import {fullName} from '../../../../store/user/utils';

export const subModelGridColumns: Column<ExecutionSetupDTO>[] = [
  {id: 'name', label: 'Name', sortable: true, value: (o) => o.name},
  {
    id: 'createdBy',
    label: 'Created by',
    sortable: true,
    value: (es) => (es.createdBy ? fullName(es.createdBy) : ''),
  },
  {
    id: 'createdOn',
    label: 'Created',
    sortable: true,
    value: (es) => es.createdOn,
    display: (es) => es.createdOn?.toLocaleDateString('en-US', TO_LOCALE_DATE_STRING_OPTIONS),
  },

  {
    id: 'modifiedBy',
    label: 'Modified by',
    sortable: true,
    value: (es) => (es.modifiedBy ? fullName(es.modifiedBy) : ''),
  },
  {
    id: 'modifiedOn',
    label: 'Modified on',
    sortable: true,
    value: (es) => es.modifiedOn,
    display: (es) => es.modifiedOn?.toLocaleDateString('en-US', TO_LOCALE_DATE_STRING_OPTIONS),
  },
];
